import styled, { css } from 'styled-components'

// NOTE: some styles are rendered inline via ref, due to performance
export const OverlayContainer = styled.div(
  ({ theme }) => css`
    position: fixed;
    top: 0;
    left: 0;
    z-index: ${theme.zIndex.level1};
  `,
)
